import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { HeroButtons } from './HeroButtons';

const CONTAINER_INITIAL = { opacity: 0, x: -50 };
const CONTAINER_ANIMATE = { opacity: 1, x: 0 };
const CONTAINER_TRANSITION = { duration: 0.8 };
const FADE_UP_INITIAL = { opacity: 0, y: 20 };
const FADE_UP_ANIMATE = { opacity: 1, y: 0 };
const DELAYS = { badge: { delay: 0.2 }, title: { delay: 0.3 }, subtitle: { delay: 0.4 }, desc: { delay: 0.5 }, buttons: { delay: 0.6 } };

const FadeUp = ({ as = 'div', step, className, children }) => {
  const Tag = motion[as];
  return (
    <Tag initial={FADE_UP_INITIAL} animate={FADE_UP_ANIMATE} transition={DELAYS[step]} className={className}>
      {children}
    </Tag>
  );
};

const HeroContent = ({ onScrollTo }) => {
  const { t, language } = useLanguage();

  return (
    <motion.div initial={CONTAINER_INITIAL} animate={CONTAINER_ANIMATE} transition={CONTAINER_TRANSITION} className="text-left">
      <FadeUp step="badge" className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30 mb-6">
        <Sparkles className="w-4 h-4 text-orange-400" />
        <span className="text-sm text-blue-300 font-medium">MRK Digital Consultancy</span>
      </FadeUp>
      <FadeUp as="h1" step="title" className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
        <span className="bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">{t.hero.title}</span>
      </FadeUp>
      <FadeUp as="p" step="subtitle" className="text-xl md:text-2xl text-gray-300 mb-4 font-light">
        {t.hero.subtitle}
      </FadeUp>
      <FadeUp as="p" step="desc" className="text-lg text-gray-400 mb-8">
        {t.hero.description}
      </FadeUp>
      <FadeUp step="buttons" className="flex flex-col sm:flex-row gap-4">
        <HeroButtons t={t} language={language} onScrollTo={onScrollTo} />
      </FadeUp>
    </motion.div>
  );
};

export default HeroContent;
